export default __webpack_public_path__ + "static/card-visa-debit@3x-df1f755638a34ef17d711053c061889b.png";